import { createSelector } from '@reduxjs/toolkit';

import { ANZSIC_TO_CPI_TYPES } from '../constants/domain-specific';
import type { RootState } from '../store';
import { AnzsicCPIType } from '../types/cover';
import { isTruthyArray } from '../utils';

export const selectBusinessDetails = (state: RootState) => state.businessDetails;

export const selectIsPropertyOwner = (state: RootState) =>
  state.businessDetails?.propertyType === 'single-tenant';

export const selectIsBusinessDetailsValid = createSelector(
  selectBusinessDetails,
  selectIsPropertyOwner,
  (
    {
      coverStart,
      dutyOfDisclosure,
      occupation,
      employeeCount,
      annualTurnover,
      businessAddress,
      fullBusinessAddress,
      addressLine1,
      suburb,
      state,
      postcode,
      isValidAddress,
      propertyValue,
    },
    isPropertyOwner
  ) =>
    isTruthyArray([
      coverStart,
      dutyOfDisclosure,
      occupation,
      isPropertyOwner ? true : employeeCount,
      isPropertyOwner ? propertyValue : true,
      annualTurnover,
      ...(businessAddress
        ? [fullBusinessAddress]
        : /** @clarify do we need isValidAddress ? or can we just use that instead of these other fields? */
          [addressLine1, suburb, state, postcode, isValidAddress]),
    ])
);

export const selectIsSpecificBusinessDetailsValid = createSelector(
  selectBusinessDetails,
  ({
    employeeCount,
    annualTurnover,
    addressLine1,
    suburb,
    state,
    postcode,
    isValidAddress,
    businessAddress,
    fullBusinessAddress,
  }) =>
    isTruthyArray([
      employeeCount &&
        annualTurnover &&
        (addressLine1
          ? suburb && state && postcode && isValidAddress
          : businessAddress && fullBusinessAddress),
    ])
);

export const selectIsElectricianQld = createSelector(
  selectBusinessDetails,
  ({ occupation }) =>
    occupation?.anzsicCode &&
    ANZSIC_TO_CPI_TYPES[occupation.anzsicCode]?.includes(AnzsicCPIType.ElectricianQLD)
);

export const selectIsPlumberVic = createSelector(
  selectBusinessDetails,
  ({ occupation }) =>
    occupation?.anzsicCode &&
    ANZSIC_TO_CPI_TYPES[occupation.anzsicCode]?.includes(AnzsicCPIType.PlumberVIC)
);
